'use client'

import { useState } from 'react'
import { cn } from '@/utilities/cn'

interface ExpandableTextProps {
  text: string
  maxLength?: number
  className?: string
}

export function ExpandableText({ text, maxLength = 150, className }: ExpandableTextProps) {
  const [isExpanded, setIsExpanded] = useState(false)
  const shouldTruncate = text.length > maxLength

  if (!shouldTruncate) {
    return <div className={className}>{text}</div>
  }

  const displayText = isExpanded ? text : text.slice(0, maxLength) + '...'

  return (
    <div className={className}>
      {displayText}
      {shouldTruncate && (
        <>
          {' '}
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-ocean-blue hover:text-primary transition-colors underline font-medium"
          >
            {isExpanded ? 'minder' : 'lees meer'}
          </button>
        </>
      )}
    </div>
  )
}
